/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { makeStyles } from 'tss-react/mui';

import { Theme } from '@mui/material/styles';

const LoginViewUseStyles = makeStyles()((theme: Theme) => ({
	container: {
		position: 'relative',
		width: '100%',
		height: '100%',
		maxWidth: 'calc(1320px / 2)',
	},

	right: {
		position: 'relative',
		width: '50%',
		padding: theme.spacing(8),
		paddingTop: theme.spacing(2),
		backgroundColor: theme.palette.secondary.main,
		overflowY: 'auto',
	},

	content: {
		width: '100%',
		height: '100%',
		maxWidth: '600px',
		zIndex: 2,
		position: 'relative',
	},

	background: {
		position: 'absolute',
		width: '100%',
		padding: '100px 0px',
		top: '0',
		left: '0',
		zIndex: 1,
	},

	highlight: {
		borderRadius: '50%',
		width: '100%',
		height: 'auto',
		paddingBottom: '100%',
	},

	contentRight: {
		position: 'relative',
		zIndex: 2,
		width: '60%',
		margin: '0 auto',
		padding: '50px',
		paddingTop: '150px',
		color: theme.palette.common.white,
		'text-align': 'center',
		'& img': {
			width: '100%',
			marginBottom: theme.spacing(4),
		},
	},

	login: {
		fontFamily: theme.typography.fontFamilyBold,
		color: theme.palette.common.white,
		position: 'absolute',
		right: '0',
		zIndex: 3,
	},

	mobilePreview: {
		borderRadius: '16px',
		overflow: 'hidden',
		boxShadow: '0 0 0 0.5px #00000080, 0 1px 3px 0 #0000003D, 0 2px 8px 0 #0000001F',
	},
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default LoginViewUseStyles;
